var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectWithUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 7.5,
    fill: "#0433EF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 7.5,
    stroke: "#0433EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7716 36.0653C48.9637 33.6258 48.5015 31.1792 47.4328 28.9778C45.6639 30.6585 43.5729 31.9635 41.2859 32.8141C41.4698 35.0713 41.368 37.3427 40.9828 39.5744C43.7658 38.8735 46.4027 37.6855 48.7716 36.0653ZM38.7317 40.0292C39.1842 37.8659 39.3424 35.6515 39.202 33.4459C37.8533 33.7675 36.4466 33.9375 35.0002 33.9375C33.5538 33.9375 32.147 33.7675 30.7984 33.4459C30.6613 35.6515 30.8195 37.8655 31.2687 40.0292C33.7419 40.4083 36.2585 40.4083 38.7317 40.0292ZM31.8439 42.2519C33.9408 42.5 36.0596 42.5 38.1565 42.2519C37.4358 44.5718 36.3719 46.7708 35.0002 48.7757C33.6284 46.7708 32.5645 44.5718 31.8439 42.2519ZM29.0176 39.5758C28.6303 37.3434 28.5285 35.0708 28.7144 32.8127C26.4269 31.9623 24.3354 30.6572 22.5661 28.9763C21.4977 31.1783 21.036 33.6254 21.2288 36.0653C23.5976 37.6855 26.2346 38.8749 29.0176 39.5758ZM48.2545 38.8987C47.5393 41.3225 46.1737 43.5041 44.3061 45.2066C42.4385 46.9091 40.1402 48.0675 37.6607 48.5561C38.9024 46.4683 39.8501 44.2191 40.477 41.8723C43.2105 41.2993 45.8356 40.2961 48.2545 38.9001V38.8987ZM21.7458 38.8987C24.1287 40.2743 26.7467 41.29 29.5233 41.8723C30.1502 44.2191 31.0979 46.4683 32.3397 48.5561C29.8604 48.0677 27.5622 46.9095 25.6946 45.2072C23.827 43.5049 22.4613 41.3237 21.7458 38.9001V38.8987ZM37.6607 21.4425C41.1708 22.1324 44.2766 24.1566 46.325 27.0893C44.813 28.617 43.0079 29.8236 41.0182 30.6367C40.4821 27.3894 39.3433 24.2711 37.6607 21.4425ZM35.0002 21.2243C37.0677 24.2448 38.4261 27.6933 38.9739 31.3124C37.7032 31.6383 36.3715 31.8125 35.0002 31.8125C33.6288 31.8125 32.2972 31.6397 31.0264 31.3124C31.5742 27.6933 32.9326 24.2448 35.0002 21.2243ZM32.3397 21.4425C30.657 24.2711 29.5183 27.3894 28.9822 30.6367C26.9924 29.8236 25.1874 28.6171 23.6753 27.0893C25.7239 24.157 28.8297 22.1319 32.3397 21.4425Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectWithUs);
export default __webpack_public_path__ + "static/media/Connect With Us.8cc5118dde6cd105b358bb5ec45e83b5.svg";
export { ForwardRef as ReactComponent };